(function () {
  const CURRENT_GROUP = window.BOLD_CUSTOMER_PRICING_GROUP || 'guest';
  const STORED_GROUP_KEY = 'bold_customer_pricing_group';

  const MONEY_SELECTOR = [
    '.money[data-product-id]',
    '.money[data-product-handle]',
    '.money[data-variant-id]',
    '.money[data-line-index]',
    '.money[data-cart-total]'
  ].join(',');

  const READY_CLASS = 'bold-price-ready';
  const VARIANT_PICKER = 'variant-selects, variant-radios, .product-form__input';

  // ── Timings ────────────────────────────────────────────────────────────────
  // REVEAL_MS: wait before showing a price we have not seen before. Measured
  //   from script start (page load) or from the variant change.
  // FORCE_MS:  unconditional reveals so a price can never stay blank.
  const REVEAL_MS = 1250;
  const FORCE_MS = [1800, 3000, 5000, 8000];
  const START_TIME = Date.now();

  // [PRICE-FIX] ───────────────────────────────────────────────────────────────
  // Tagged customers (storeseller / onlineseller) must never see an in-between
  // price on the product page. While the main product price is either
  //   (a) the product's LOWEST variant price while a different variant is
  //       selected (the "from" price Bold shows first), or
  //   (b) still being rewritten (changed in the last QUIET_MS),
  // the reveal is held back and re-checked every HOLD_POLL_MS.
  // HOLD_CAP_MS is the safety limit so a price can never stay blank.
  const TAGGED_GROUPS = ['storeseller', 'onlineseller', 'customer-'];
  const GUARD_ACTIVE = TAGGED_GROUPS.some(function (t) {
    return String(CURRENT_GROUP).toLowerCase().indexOf(t) > -1;
  });
  const QUIET_MS = 600;          // price must be unchanged this long before a NEW price is revealed
  const MIN_UNKNOWN_MS = 1800;   // a price we have never verified is never revealed before this
  const HOLD_POLL_MS = 60;
  const HOLD_CAP_MS = 8000;      // safety cap: a blank price is better than a wrong one, but never forever

  let holdStart = START_TIME;         // reset on every variant change
  let lastPriceMutation = 0;          // last time something rewrote a .f-price
  let holdPollTimer = null;
  const productCache = Object.create(null); // handle -> { variants, min } | null (failed)

  function currentHandle() {
    const m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  // Shopify base prices of the product, loaded once per product page.
  // Returns undefined while loading, null if unavailable / not a product page.
  function productFor(handle) {
    if (!handle) return null;
    if (handle in productCache) return productCache[handle];
    productCache[handle] = undefined;
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        const prices = p.variants.map(function (v) { return v.price / 100; });
        productCache[handle] = { variants: p.variants, min: Math.min.apply(null, prices) };
      })
      .catch(function () { productCache[handle] = null; });
    return undefined;
  }

  function parseMoney(text) {
    if (!text) return null;
    const m = String(text).replace(/[^0-9.,-]/g, '').replace(/,/g, '').match(/\d+(\.\d+)?/);
    return m ? Number(m[0]) : null;
  }

  function shownAmount(block) {
    const el =
      block.querySelector('.f-price-item--sale .money') ||
      block.querySelector('.f-price-item--regular .money') ||
      block.querySelector('.money');
    return el ? parseMoney(el.textContent) : null;
  }

  // Should this price block still be held back?
  function holdBlock(block) {
    if (!GUARD_ACTIVE) return false;
    if (Date.now() - holdStart > HOLD_CAP_MS) return false;       // safety cap

    const scope = block.closest('product-info, product-form, .product__info-container, .main-product, .product');
    if (!scope || mainPriceEl(scope) !== block) return false;     // only the main product price

    const handle = currentHandle();
    if (!handle) return false;
    const product = productFor(handle);
    if (product === undefined) return true;                       // product data still loading
    if (product === null) return false;                           // unavailable: old behaviour

    const vid = currentVariantId(scope);
    if (!vid) return false;
    let variant = null;
    for (let i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].id) === vid) { variant = product.variants[i]; break; }
    }
    if (!variant) return false;

    const base = variant.price / 100;
    const shown = shownAmount(block);
    if (shown === null) return false;                             // no price rendered: old behaviour

    // 1) lowest "from" price showing while a different variant is selected
    if (shown === product.min && base !== product.min) return true;

    // 2) VERIFIED: we have seen this tag's final price for this variant before.
    //    Reveal only when the page shows exactly that price.
    const expected = expectedPrice(vid);
    if (expected !== null) return shown !== expected;

    // 3) FIRST TIME for this tag + variant: wait until the price has settled
    if (msrpPending(block)) return true;                          // MSRP markup not applied yet
    if (Date.now() - holdStart < MIN_UNKNOWN_MS) return true;
    return Date.now() - lastPriceMutation < QUIET_MS;             // still being rewritten
  }

  // Final prices seen per customer tag (and MSRP setting) and variant, kept in
  // localStorage. The key contains "bold", so a customer change clears it.
  function priceKey() {
    const en = lsGet('b2b_msrp_enabled') === 'true';
    const pct = en ? (lsGet('b2b_msrp_percent') || '0') : '0';
    return 'bold_final_prices_v1|' + String(CURRENT_GROUP).toLowerCase() + '|' + pct;
  }
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function expectedPrice(vid) {
    try {
      const o = JSON.parse(lsGet(priceKey()) || '{}');
      return typeof o[vid] === 'number' ? o[vid] : null;
    } catch (e) { return null; }
  }
  function rememberPrice(vid, amount) {
    try {
      const k = priceKey();
      const o = JSON.parse(lsGet(k) || '{}');
      o[vid] = amount;
      localStorage.setItem(k, JSON.stringify(o));
    } catch (e) {}
  }
  function msrpPending(block) {
    const en = lsGet('b2b_msrp_enabled') === 'true';
    const pct = Number(lsGet('b2b_msrp_percent') || 0);
    return en && pct > 0 && !block.hasAttribute('data-b2b-msrp-active');
  }
  // Called only when a main product price was revealed normally (not by the safety cap).
  function recordRevealedPrice(block) {
    if (!GUARD_ACTIVE) return;
    // After the safety cap, only relearn the price if it has actually settled
    // (this self-heals a remembered price that no longer matches Bold).
    if (Date.now() - holdStart > HOLD_CAP_MS && Date.now() - lastPriceMutation < QUIET_MS) return;
    const scope = block.closest('product-info, product-form, .product__info-container, .main-product, .product');
    if (!scope || mainPriceEl(scope) !== block) return;
    const vid = currentVariantId(scope);
    const shown = shownAmount(block);
    if (!vid || shown === null || msrpPending(block)) return;
    rememberPrice(vid, shown);
  }

  // Note when Bold / the MSRP script rewrites a price (content only, so our own
  // class changes are not counted).
  try {
    new MutationObserver(function (mutations) {
      for (let i = 0; i < mutations.length; i++) {
        let t = mutations[i].target;
        if (t && t.nodeType === 3) t = t.parentElement;
        if (t && t.closest && t.closest('.f-price')) { lastPriceMutation = Date.now(); return; }
      }
    }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  } catch (e) {}
  // ── end [PRICE-FIX] additions (other changes are marked inline) ───────────

  // Bold's final price for each variant, once we have seen it. Switching back
  // to a cached variant is instant - no wait, no rolling.
  const priceCache = Object.create(null);

  function clearStalePricingStateIfCustomerChanged() {
    const previousGroup = sessionStorage.getItem(STORED_GROUP_KEY);

    if (previousGroup && previousGroup !== CURRENT_GROUP) {
      sessionStorage.removeItem('b2b_msrp_percent');
      sessionStorage.removeItem('b2b_msrp_enabled');
      sessionStorage.removeItem('b2b_msrp_mode');
      sessionStorage.removeItem('b2b_msrp_markup');

      try {
        Object.keys(localStorage).forEach(function (key) {
          if (key.toLowerCase().includes('bold')) localStorage.removeItem(key);
        });
        Object.keys(sessionStorage).forEach(function (key) {
          if (key.toLowerCase().includes('bold')) sessionStorage.removeItem(key);
        });
      } catch (error) {}
    }

    sessionStorage.setItem(STORED_GROUP_KEY, CURRENT_GROUP);
  }

  clearStalePricingStateIfCustomerChanged();

  function els(scope, selector) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  // [PRICE-FIX] showPrices now skips a block that is still on a placeholder price
  // and re-checks shortly. Everything else is unchanged.
  function showPrices(scope) {
    const targetScope = scope || document;
    let held = false;

    els(targetScope, '.f-price').forEach(function (el) {
      if (holdBlock(el)) { held = true; return; }
      if (!el.classList.contains(READY_CLASS)) recordRevealedPrice(el);   // [PRICE-FIX] remember the verified price
      el.classList.add(READY_CLASS);
    });
    els(targetScope, MONEY_SELECTOR).forEach(function (el) {
      const block = el.closest('.f-price');
      if (block && !block.classList.contains(READY_CLASS)) return;
      el.classList.add(READY_CLASS);
    });
    if (targetScope !== document && targetScope.classList) targetScope.classList.add(READY_CLASS);

    if (held && !holdPollTimer) {
      holdPollTimer = setTimeout(function () {
        holdPollTimer = null;
        showPrices(targetScope);
      }, HOLD_POLL_MS);
    }
  }

  function hidePrices(scope) {
    const targetScope = scope || document;
    holdStart = Date.now();                                  // [PRICE-FIX] restart the hold window
    els(targetScope, MONEY_SELECTOR).forEach(function (el) { el.classList.remove(READY_CLASS); });
    els(targetScope, '.f-price').forEach(function (el) { el.classList.remove(READY_CLASS); });
  }

  // Unconditional safety reveals for the whole page.
  // [PRICE-FIX] these still run, but showPrices() now holds a placeholder price
  // until HOLD_CAP_MS, so they can no longer expose the lowest price early.
  FORCE_MS.forEach(function (delay) {
    setTimeout(function () { showPrices(document); }, delay);
  });

  function refreshBoldPricing() {
    try {
      if (window.BOLD && window.BOLD.common && window.BOLD.common.eventEmitter) {
        window.BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
        window.BOLD.common.eventEmitter.emit('BOLD_COMMON_product_loaded');
      }
    } catch (error) {}

    try {
      document.dispatchEvent(new CustomEvent('bold:refresh'));
      document.dispatchEvent(new CustomEvent('bold:prices:refresh'));
      document.dispatchEvent(new CustomEvent('bold:pricing:refresh'));
    } catch (error) {}
  }

  function getProductScope(target) {
    if (!target || !target.closest) return document;
    return (
      target.closest('product-info') ||
      target.closest('product-form') ||
      target.closest('.product__info-container') ||
      target.closest('.product') ||
      target.closest('.main-product') ||
      document
    );
  }

  // Which variant is currently selected in this scope?
  function currentVariantId(scope) {
    const root = scope && scope.querySelector ? scope : document;
    const input = root.querySelector('[name="id"]');
    if (input && input.value) return String(input.value);
    try {
      const fromUrl = new URLSearchParams(window.location.search).get('variant');
      if (fromUrl) return String(fromUrl);
    } catch (e) {}
    return null;
  }

  function mainPriceEl(scope) {
    const root = scope && scope.querySelector ? scope : document;
    return root.querySelector('.f-price');
  }

  // Remember Bold's finished price for this variant.
  function cachePrice(scope) {
    const el = mainPriceEl(scope);
    const vid = currentVariantId(scope);
    if (!el || !vid) return;
    if (holdBlock(el)) return;                               // [PRICE-FIX] never cache a placeholder
    const html = el.innerHTML;
    if (html && html.indexOf('$') !== -1) priceCache[vid] = html;
  }

  // Show a cached price instantly, if we have one for the selected variant.
  function applyCachedPrice(scope) {
    const el = mainPriceEl(scope);
    const vid = currentVariantId(scope);
    if (!el || !vid || !priceCache[vid]) return false;
    el.innerHTML = priceCache[vid];
    showPrices(scope);
    return true;
  }

  function revealAndCache(scope) {
    showPrices(scope);
    cachePrice(scope);
  }

  // Reveal once, then remember the result.
  function revealWhenSettled(scope) {
    const targetScope = scope || document;

    let wait = REVEAL_MS;
    if (targetScope === document) {
      wait = Math.max(0, REVEAL_MS - (Date.now() - START_TIME));
    }

    if (targetScope.__boldReveal) clearTimeout(targetScope.__boldReveal);
    if (targetScope.__boldForce) clearTimeout(targetScope.__boldForce);

    targetScope.__boldReveal = setTimeout(function () { revealAndCache(targetScope); }, wait);
    targetScope.__boldForce = setTimeout(function () { revealAndCache(targetScope); }, wait + 1200);
  }

  function repriceAndReveal(scope) {
    setTimeout(refreshBoldPricing, 50);
    revealWhenSettled(scope);
  }

  // ── Variant switching ───────────────────────────────────────────────────────
  // Hide immediately so no intermediate price is ever shown, then:
  //   - if we already know Bold's price for the new variant, show it at once
  //   - otherwise wait once, then show and remember it
  function handleVariantInteraction(target) {
    const scope = getProductScope(target);
    const before = currentVariantId(scope);

    hidePrices(scope);

    let tries = 0;
    (function waitForVariant() {
      const now = currentVariantId(scope);
      tries++;

      if (now && now !== before) {
        if (applyCachedPrice(scope)) return; // instant, already known
        repriceAndReveal(scope);
        return;
      }

      if (tries < 20) {
        setTimeout(waitForVariant, 40); // up to ~800ms for the theme to update
        return;
      }

      repriceAndReveal(scope); // variant never changed: reveal anyway
    })();
  }

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;
    const picker = event.target.closest(VARIANT_PICKER);
    if (!picker) return;
    handleVariantInteraction(picker);
  }, true);

  document.addEventListener('change', function (event) {
    if (!event.target || !event.target.closest) return;
    const picker = event.target.closest(VARIANT_PICKER);
    if (!picker) return;
    handleVariantInteraction(picker);
  }, true);

  document.addEventListener('variant:changed', function (event) {
    handleVariantInteraction(event.target || document);
  });

  document.addEventListener('variant:change', function (event) {
    handleVariantInteraction(event.target || document);
  });

  // ── Page load ───────────────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () { repriceAndReveal(document); });
  window.addEventListener('load', function () { repriceAndReveal(document); });

  // ── Hyperspeed instant navigation + Shopify section reloads ─────────────────
  ['hs:navigated', 'hs:page-load', 'hs:after-render', 'hs:loaded',
   'page:load', 'page:loaded', 'page:change', 'shopify:section:load'
  ].forEach(function (evt) {
    document.addEventListener(evt, function () {
      // NOTE: no hidePrices() here. Hyperspeed fires these events on hover
      // prefetch as well as real navigation, and hiding on them blanked the
      // price whenever the mouse passed over a link. New content arrives
      // without the ready class, so it is already hidden by CSS anyway.
      holdStart = Date.now();                                // [PRICE-FIX] new page: restart the hold window
      repriceAndReveal(document);
      FORCE_MS.forEach(function (delay) {
        setTimeout(function () { showPrices(document); }, delay);
      });
    });
  });

  window.addEventListener('popstate', function () {
    holdStart = Date.now();                                  // [PRICE-FIX]
    repriceAndReveal(document);
    FORCE_MS.forEach(function (delay) {
      setTimeout(function () { showPrices(document); }, delay);
    });
  });

  // ── Persistent guard ────────────────────────────────────────────────────────
  let persistentSettle = null;
  try {
    new MutationObserver(function (mutations) {
      const sawNew = mutations.some(function (m) {
        return Array.prototype.slice.call(m.addedNodes).some(function (n) {
          return n.nodeType === 1 && (
            (n.matches && (n.matches(MONEY_SELECTOR) || n.matches('.f-price'))) ||
            (n.querySelector && (n.querySelector(MONEY_SELECTOR) || n.querySelector('.f-price')))
          );
        });
      });
      if (!sawNew) return;
      clearTimeout(persistentSettle);
      persistentSettle = setTimeout(function () { showPrices(document); }, REVEAL_MS);
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();














// old bold code for pricing 












// (function () {
//   const CURRENT_GROUP = window.BOLD_CUSTOMER_PRICING_GROUP || 'guest';
//   const STORED_GROUP_KEY = 'bold_customer_pricing_group';

//   const MONEY_SELECTOR = [
//     '.money[data-product-id]',
//     '.money[data-product-handle]',
//     '.money[data-variant-id]',
//     '.money[data-line-index]',
//     '.money[data-cart-total]'
//   ].join(',');

//   const READY_CLASS = 'bold-price-ready';
//   const VARIANT_PICKER = 'variant-selects, variant-radios, .product-form__input';

//   // ── Timings ────────────────────────────────────────────────────────────────
//   // REVEAL_MS: wait before showing a price we have not seen before. Measured
//   //   from script start (page load) or from the variant change.
//   // FORCE_MS:  unconditional reveals so a price can never stay blank.
//   const REVEAL_MS = 1250;
//   const FORCE_MS = [1800, 3000, 5000, 8000];
//   const START_TIME = Date.now();

//   // Bold's final price for each variant, once we have seen it. Switching back
//   // to a cached variant is instant - no wait, no rolling.
//   const priceCache = Object.create(null);

//   function clearStalePricingStateIfCustomerChanged() {
//     const previousGroup = sessionStorage.getItem(STORED_GROUP_KEY);

//     if (previousGroup && previousGroup !== CURRENT_GROUP) {
//       sessionStorage.removeItem('b2b_msrp_percent');
//       sessionStorage.removeItem('b2b_msrp_enabled');
//       sessionStorage.removeItem('b2b_msrp_mode');
//       sessionStorage.removeItem('b2b_msrp_markup');

//       try {
//         Object.keys(localStorage).forEach(function (key) {
//           if (key.toLowerCase().includes('bold')) localStorage.removeItem(key);
//         });
//         Object.keys(sessionStorage).forEach(function (key) {
//           if (key.toLowerCase().includes('bold')) sessionStorage.removeItem(key);
//         });
//       } catch (error) {}
//     }

//     sessionStorage.setItem(STORED_GROUP_KEY, CURRENT_GROUP);
//   }

//   clearStalePricingStateIfCustomerChanged();

//   function els(scope, selector) {
//     return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
//   }

//   function showPrices(scope) {
//     const targetScope = scope || document;
//     els(targetScope, MONEY_SELECTOR).forEach(function (el) { el.classList.add(READY_CLASS); });
//     els(targetScope, '.f-price').forEach(function (el) { el.classList.add(READY_CLASS); });
//     if (targetScope !== document && targetScope.classList) targetScope.classList.add(READY_CLASS);
//   }

//   function hidePrices(scope) {
//     const targetScope = scope || document;
//     els(targetScope, MONEY_SELECTOR).forEach(function (el) { el.classList.remove(READY_CLASS); });
//     els(targetScope, '.f-price').forEach(function (el) { el.classList.remove(READY_CLASS); });
//   }

//   // Unconditional safety reveals for the whole page.
//   FORCE_MS.forEach(function (delay) {
//     setTimeout(function () { showPrices(document); }, delay);
//   });

//   function refreshBoldPricing() {
//     try {
//       if (window.BOLD && window.BOLD.common && window.BOLD.common.eventEmitter) {
//         window.BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
//         window.BOLD.common.eventEmitter.emit('BOLD_COMMON_product_loaded');
//       }
//     } catch (error) {}

//     try {
//       document.dispatchEvent(new CustomEvent('bold:refresh'));
//       document.dispatchEvent(new CustomEvent('bold:prices:refresh'));
//       document.dispatchEvent(new CustomEvent('bold:pricing:refresh'));
//     } catch (error) {}
//   }

//   function getProductScope(target) {
//     if (!target || !target.closest) return document;
//     return (
//       target.closest('product-info') ||
//       target.closest('product-form') ||
//       target.closest('.product__info-container') ||
//       target.closest('.product') ||
//       target.closest('.main-product') ||
//       document
//     );
//   }

//   // Which variant is currently selected in this scope?
//   function currentVariantId(scope) {
//     const root = scope && scope.querySelector ? scope : document;
//     const input = root.querySelector('[name="id"]');
//     if (input && input.value) return String(input.value);
//     try {
//       const fromUrl = new URLSearchParams(window.location.search).get('variant');
//       if (fromUrl) return String(fromUrl);
//     } catch (e) {}
//     return null;
//   }

//   function mainPriceEl(scope) {
//     const root = scope && scope.querySelector ? scope : document;
//     return root.querySelector('.f-price');
//   }

//   // Remember Bold's finished price for this variant.
//   function cachePrice(scope) {
//     const el = mainPriceEl(scope);
//     const vid = currentVariantId(scope);
//     if (!el || !vid) return;
//     const html = el.innerHTML;
//     if (html && html.indexOf('$') !== -1) priceCache[vid] = html;
//   }

//   // Show a cached price instantly, if we have one for the selected variant.
//   function applyCachedPrice(scope) {
//     const el = mainPriceEl(scope);
//     const vid = currentVariantId(scope);
//     if (!el || !vid || !priceCache[vid]) return false;
//     el.innerHTML = priceCache[vid];
//     showPrices(scope);
//     return true;
//   }

//   function revealAndCache(scope) {
//     showPrices(scope);
//     cachePrice(scope);
//   }

//   // Reveal once, then remember the result.
//   function revealWhenSettled(scope) {
//     const targetScope = scope || document;

//     let wait = REVEAL_MS;
//     if (targetScope === document) {
//       wait = Math.max(0, REVEAL_MS - (Date.now() - START_TIME));
//     }

//     if (targetScope.__boldReveal) clearTimeout(targetScope.__boldReveal);
//     if (targetScope.__boldForce) clearTimeout(targetScope.__boldForce);

//     targetScope.__boldReveal = setTimeout(function () { revealAndCache(targetScope); }, wait);
//     targetScope.__boldForce = setTimeout(function () { revealAndCache(targetScope); }, wait + 1200);
//   }

//   function repriceAndReveal(scope) {
//     setTimeout(refreshBoldPricing, 50);
//     revealWhenSettled(scope);
//   }

//   // ── Variant switching ───────────────────────────────────────────────────────
//   // Hide immediately so no intermediate price is ever shown, then:
//   //   - if we already know Bold's price for the new variant, show it at once
//   //   - otherwise wait once, then show and remember it
//   function handleVariantInteraction(target) {
//     const scope = getProductScope(target);
//     const before = currentVariantId(scope);

//     hidePrices(scope);

//     let tries = 0;
//     (function waitForVariant() {
//       const now = currentVariantId(scope);
//       tries++;

//       if (now && now !== before) {
//         if (applyCachedPrice(scope)) return; // instant, already known
//         repriceAndReveal(scope);
//         return;
//       }

//       if (tries < 20) {
//         setTimeout(waitForVariant, 40); // up to ~800ms for the theme to update
//         return;
//       }

//       repriceAndReveal(scope); // variant never changed: reveal anyway
//     })();
//   }

//   document.addEventListener('click', function (event) {
//     if (!event.target || !event.target.closest) return;
//     const picker = event.target.closest(VARIANT_PICKER);
//     if (!picker) return;
//     handleVariantInteraction(picker);
//   }, true);

//   document.addEventListener('change', function (event) {
//     if (!event.target || !event.target.closest) return;
//     const picker = event.target.closest(VARIANT_PICKER);
//     if (!picker) return;
//     handleVariantInteraction(picker);
//   }, true);

//   document.addEventListener('variant:changed', function (event) {
//     handleVariantInteraction(event.target || document);
//   });

//   document.addEventListener('variant:change', function (event) {
//     handleVariantInteraction(event.target || document);
//   });

//   // ── Page load ───────────────────────────────────────────────────────────────
//   document.addEventListener('DOMContentLoaded', function () { repriceAndReveal(document); });
//   window.addEventListener('load', function () { repriceAndReveal(document); });

//   // ── Hyperspeed instant navigation + Shopify section reloads ─────────────────
//   ['hs:navigated', 'hs:page-load', 'hs:after-render', 'hs:loaded',
//    'page:load', 'page:loaded', 'page:change', 'shopify:section:load'
//   ].forEach(function (evt) {
//     document.addEventListener(evt, function () {
//       // NOTE: no hidePrices() here. Hyperspeed fires these events on hover
//       // prefetch as well as real navigation, and hiding on them blanked the
//       // price whenever the mouse passed over a link. New content arrives
//       // without the ready class, so it is already hidden by CSS anyway.
//       repriceAndReveal(document);
//       FORCE_MS.forEach(function (delay) {
//         setTimeout(function () { showPrices(document); }, delay);
//       });
//     });
//   });

//   window.addEventListener('popstate', function () {
//     repriceAndReveal(document);
//     FORCE_MS.forEach(function (delay) {
//       setTimeout(function () { showPrices(document); }, delay);
//     });
//   });

//   // ── Persistent guard ────────────────────────────────────────────────────────
//   let persistentSettle = null;
//   try {
//     new MutationObserver(function (mutations) {
//       const sawNew = mutations.some(function (m) {
//         return Array.prototype.slice.call(m.addedNodes).some(function (n) {
//           return n.nodeType === 1 && (
//             (n.matches && (n.matches(MONEY_SELECTOR) || n.matches('.f-price'))) ||
//             (n.querySelector && (n.querySelector(MONEY_SELECTOR) || n.querySelector('.f-price')))
//           );
//         });
//       });
//       if (!sawNew) return;
//       clearTimeout(persistentSettle);
//       persistentSettle = setTimeout(function () { showPrices(document); }, REVEAL_MS);
//     }).observe(document.documentElement, { childList: true, subtree: true });
//   } catch (e) {}
// })();
